import React, { ReactNode } from 'react';
import { cn } from '../cn';
import { panelVariants } from '../recipes/panel';

type PanelProps = React.HTMLAttributes<HTMLDivElement> & {
  padding?: 'default' | 'compact' | 'none';
  overflow?: 'visible' | 'hidden';
};

export function Panel({
  padding = 'default',
  overflow,
  className,
  children,
  ...attrs
}: PanelProps) {
  return (
    <div
      className={cn(panelVariants({ padding, overflow }), className)}
      {...attrs}
    >
      {children}
    </div>
  );
}

export function DataTable({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn(panelVariants({ padding: 'none', overflow: 'hidden' }), className)}>
      <div className="overflow-x-auto">{children}</div>
    </div>
  );
}
